// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__7KMLx","subTitleBold":"BoxSubTitle_subTitleBold__Xa3kp"};